<form [formGroup]="form">
  <app-file-upload-area *ngIf="files.length === 0" [title]="'Datei(en) hochladen'" [text]="'.pdf, .jpg, .png, .webp'" [uploadedFiles]="files" (filesChanged)="filesUploaded($event)"></app-file-upload-area>
  
  <app-loader *ngIf="filesUploading" [text]="'Dateien werden hochgeladen...'"></app-loader>

  <div *ngIf="files && files.length > 0 && filesUploading == false" class="files-container">
    <div *ngFor="let file of files" class="file">
      <i-tabler name="file"></i-tabler>
      <span>{{file.name}}</span>
      <i-tabler class="remove" name="x" (click)="removeFile(file)"></i-tabler>
    </div>
  </div>

  <app-divider *ngIf="deviceType !== 'desktop' && files.length === 0" [text]="'oder'"></app-divider>

  <div *ngIf="deviceType !== 'desktop' && files.length === 0" class="additional-options">
    <app-upload-button [action]="'camera'" [icon]="'camera'" [text]="'Foto aufnehmen'" (filesChanged)="filesUploaded($event)"></app-upload-button>
    <app-upload-button [action]="'gallery'" [icon]="'library-photo'" [text]="''" (filesChanged)="filesUploaded($event)"></app-upload-button>
  </div>
  
  <app-checkbox
    formControlName="promptActive"
    [control]="getControl('promptActive')"
    [label]="'Prompt hinzufügen'"
    (valueChange)="promptCheckboxValueChanged($event)">
  </app-checkbox>

  <app-textarea
    *ngIf="getControl('promptActive').value"
    formControlName="prompt"
    [control]="getControl('prompt')"
    [placeholder]="'Bitte gib deinen Prompt ein...'">
  </app-textarea>
  <div *ngIf="showRestrictionInfo && files.length > 0" class="restriction-info"><span>Achtung!</span>Die hochgeladene Datei hat mehr als 20 Seiten. Mit der kostenlosen Sparkly-Version werden dir nur für die ersten 20 Seiten Lernkarten erstellt.</div>
</form>